module.exports = __webpack_public_path__ + "static/media/Trail.336c9f70.jpg";